import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Draggable from 'react-draggable';
import '@fontsource/roboto/400.css';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Home from './pages/Home/home';
import Useraccount from './pages/Account/useraccount';
import Security from './pages/Account/security';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Paper, DialogActions, Badge, CircularProgress, requirePropFactory, Fab } from '@mui/material';
import Loadingspinner from './pages/Components/loading';
import constants from "./pages/Utils/constants.json"
import Account from './pages/Account/account';
import { HelpOutline, HomeOutlined, ListAlt, PersonOutline, PlaceOutlined } from '@mui/icons-material';
import Help from './pages/Help/help';
import { useDispatch, useSelector } from 'react-redux';
import { getFromStore, setToStore } from './pages/Utils/fn';
import fetch from './pages/Utils/fetch';
import useDocumentTitle from './hooks/useDocumentTitle';
import { setAlert } from './store/alert';
import { removeUser, setLoggedIn, setUser } from './store/user';
import { setFavorites } from './store/favorites';
import { addCartItems } from './store/cartItems';
import { setRecentlyViewed } from './store/recentlyViewed';
import { addCategories } from './store/categories';
import { updateWebSettings } from './store/webSettings';
import { setLocation } from './store/location';
import LocationModal from './pages/Components/LocationModal';
import ProductPage from './pages/Products/productpage';
import Searchitempage from './pages/Home/searchitemspage';
import Saveditems from './pages/Account/saveditems';
import Recentlyviewedpage from './pages/Account/recentlyviewed';
import Flashsales from './pages/Home/flashsales';
import Recentlysearchedpage from './pages/Account/recentlysearched';
import Cart from './pages/Account/cart';
import Allcategories from './pages/Categories/categories';
import Categoryitems from './pages/Categories/categoryitems';
import Checkoutpage from './pages/Account/checkout';
import Orderspage from './pages/Account/orders';
import Profilesettings from './pages/Account/profilemanagement';
import Faqs from './pages/Help/faq\'s';
import { addHomeCategories } from './store/homcategoriesSlice';
import { getManualDistance } from './pages/Utils/functions';



function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

export default function Sidenav() {
    const dispatch = useDispatch();
    const webSettings = useSelector((state) => state.webSettings.data);
    const locationData = useSelector((state) => state.location.data);
    const lastLoadedLocation = React.useRef(null);
    const [locationOpen, setLocationOpen] = useState(false);
    const [error, setError] = useState('');

    useDocumentTitle('Home');

    const [refresh, setrefresh] = useState(false);

    const navigate = useNavigate()
    const location = useLocation();
    const pathname = location?.pathname
    const [showaccount, setshowaccount] = useState(false);
    const [logoutdialog, setlogoutdialog] = useState(false);
    const [showcloseaccount, setshowcloseaccount] = useState(false);
    const [loading, setloading] = useState(false);
    const [cart, setcart] = useState(0);

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        shiftlocation(pathname)//update tab location
    }, [refresh, pathname]);



    useEffect(() => {
        if (webSettings) {
            const root = document.documentElement;
            const primary = webSettings.NAVBAR_TXT_COLOR || '#4f46e5';
            const accent = webSettings.ACCENT_COLOR || '#f97316';

            document.querySelector('meta[name="theme-color"]').setAttribute('content', webSettings.NAVBAR_COLOR);
            document.querySelector('meta[name="description"]').setAttribute('content', webSettings.FULL_NAME + ' website');
            // document.documentElement.style.setProperty(`--themeColor`, webSettings.NAVBAR_TXT_COLOR);


            root.style.setProperty('--primary-color', primary);
            root.style.setProperty('--primary-dark', webSettings.NAVBAR_TXT_COLOR || primary);
            root.style.setProperty('--primary-light', webSettings.NAVBAR_COLOR || `${primary}20`);

            root.style.setProperty('--accent-color', accent);
            root.style.setProperty('--accent-dark', webSettings.ACCENT_COLOR_DARK || accent);


            root.style.setProperty(`--footerBgColor`, webSettings.FOOTER_BG_COLOR);
            root.style.setProperty(`--footerTxtColor`, webSettings.FOOTER_TEXT_COLOR);
            root.style.setProperty(`--footerHeadingTxtColor`, webSettings.FOOTER_HEADING_TEXT_COLOR);
        }
    }, [webSettings]);

    useEffect(() => {
        if (locationData && !loading && locationData.mainLocation !== lastLoadedLocation.current) {
            fetch.get('getHomeProductsGroup', { location: locationData.mainLocation }).then(res => {
                const homeCats = res.list?.categories || [];
                dispatch(addHomeCategories(homeCats));
                setToStore(constants.HOME_CATEGORIES, homeCats);
                lastLoadedLocation.current = locationData.mainLocation;
            });
        }
    }, [locationData, loading, dispatch]);

    useEffect(() => {
        let favorites = getFromStore(constants.FAVORITES);
        let cartItems = getFromStore(constants.CART_ITEMS);
        let settings = getFromStore(constants.WEB_SETTINGS);
        let categories = getFromStore(constants.CATEGORIES);
        let recentlyViewed = getFromStore(constants.RECENTLY_VIEWED);
        let homeCategories = getFromStore(constants.HOME_CATEGORIES);
        let user = getFromStore(constants.USER_PROFILE);
        let cachedLocation = getFromStore(constants.CURRENT_LOCATION);

        if (user) {
            dispatch(setUser(user));
            dispatch(setLoggedIn(true));
        }
        if (cachedLocation) {
            dispatch(setLocation(cachedLocation));
        }
        if (favorites) {
            dispatch(setFavorites(favorites));
        }
        if (cartItems) {
            dispatch(addCartItems(cartItems));
        }
        if (recentlyViewed) {
            dispatch(setRecentlyViewed(recentlyViewed));
        }
        if (!settings || !categories) {
            fetchData();
        } else {
            dispatch(updateWebSettings(settings));
            dispatch(addCategories(categories));
            if (homeCategories) dispatch(addHomeCategories(homeCategories));
            fetchData(true);
        }
    }, []);

    function fetchData(updating = false) {
        if (updating) dispatch(setAlert({ type: 'warning', message: 'Updating site data...', duration: 10000 }));

        Promise.all([
            fetch.get('getWebsiteSettings'),
            fetch.get('locations'),
            fetch.get('getCompanyName')
        ])
            .then(async (res) => {
                const settings = res[0].list;
                const locations = res[1].list;
                const company = res[2].list[0];

                const finalSettings = { ...settings, ...company, locations: locations };
                dispatch(updateWebSettings(finalSettings));
                setToStore(constants.WEB_SETTINGS, finalSettings);

                // Initialize location
                // let activeLocation = await getNearestLocation(locations);
                // dispatch(setLocation(activeLocation));
                let activeLocation = getFromStore(constants.CURRENT_LOCATION);
                if (!activeLocation && locations?.length > 0) {
                    activeLocation = await getNearestLocation(locations);
                    dispatch(setLocation(activeLocation));
                }

                // Fetch products based on location
                const [homeRes, categoriesRes] = await Promise.all([
                    fetch.get('getHomeProductsGroup', { location: activeLocation?.mainLocation }),
                    fetch.get('getProductGroupsWithSubGroups', { minimum_products: 5 })
                ]);

                const homeCats = homeRes.list?.categories || [];
                const categories = categoriesRes.list;

                dispatch(addCategories(categories));
                dispatch(addHomeCategories(homeCats));
                lastLoadedLocation.current = activeLocation?.mainLocation;

                setToStore(constants.CATEGORIES, categories);
                setToStore(constants.HOME_CATEGORIES, homeCats);

                if (updating) dispatch(setAlert('Site updated successful!'));
            })
            .catch((err) => {
                if (!updating) {
                    setError(err.message);
                    dispatch(setAlert({ type: 'error', message: err.message }));
                } else {
                    dispatch(setAlert({ type: 'error', message: 'Error updating site' }));
                }
            });
    }

    const getNearestLocation = (locations) => {
        if (locations?.length === 0) return null;

        if (!navigator.geolocation) {
            return locations[0];
        }

        return new Promise((resolve) => {
            // Safety timeout: if geolocation takes too long, default to the first location
            const timeoutId = setTimeout(() => {
                console.warn("Geolocation timed out, defaulting to first location.");
                resolve(locations[0]);
            }, 5000);

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    clearTimeout(timeoutId);
                    const userLat = position.coords.latitude;
                    const userLng = position.coords.longitude;

                    let nearest = locations[0];
                    let minDistance = Infinity;

                    locations.forEach((loc) => {
                        const distance = getManualDistance(
                            userLat,
                            userLng,
                            loc.latitude,
                            loc.longitude
                        );

                        if (distance < minDistance) {
                            minDistance = distance;
                            nearest = loc;
                        }
                    });

                    resolve(nearest);
                },
                () => {
                    clearTimeout(timeoutId);
                    resolve(locations[0]);
                }
            );
        });
    }


    const shiftlocation = (pathname) => {
        const currentlocation = pathname.split("/")[1];

        if (
            currentlocation === "home" ||
            currentlocation === "product" ||
            currentlocation === "viewallmarkers" ||
            currentlocation === "todays-deals"
        ) {
            setValue(0)
        }

        if (//categories
            currentlocation === "categories" ||
            currentlocation === "categoryitems"
        ) {
            setValue(1)
        }
        if (//account routes
            currentlocation === "security" ||
            currentlocation === "useraccount" ||
            currentlocation === "account" ||
            currentlocation === "saveditems" ||
            currentlocation === "recents" ||
            currentlocation === "cart" ||
            currentlocation === "checkout" ||
            currentlocation === "orders" ||
            currentlocation === "profilesettings"
        ) {
            setValue(2)
        }

        if (//help
            currentlocation === "help" ||
            currentlocation === "faqs"
        ) {
            setValue(3)
        }
    }




    //logout from site
    const onlogout = (e) => {
        e.preventDefault();
        setlogoutdialog(false)
        setloading(true)
        setshowaccount(false)
        dispatch(removeUser());
        setTimeout(() => {
            setrefresh(!refresh)
            setloading(false)
            navigate("/home", { replace: true })
        }, 3000);
    }

    const onrefresh = () => {
        setrefresh(!refresh)
    }

    //bottom tab style
    const bottomtabstyle = {
        position: "fixed",
        bottom: 0,
        backgroundColor: "white",
        width: "100%",
    }

    //tab text style
    const tabtextstyle = {
        textTransform: "none",
        fontSize: 12
    }


    return (
        !error && !webSettings ? (
            <div className='splashscreen'>
                <img src={require("./assets/common/chokamatt_logo.jpeg")} />
            </div>
        ) : error && !webSettings ? (
            <div className="error-box">
                <section className="error-header">
                    <h3>Error!!</h3>
                </section>
                <section className="error-body">
                    <p className="error-msg">{error}</p>
                </section>
            </div>
        ) : <Box style={{ backgroundColor: '#f1f1f2' }}>
            <Dialog
                open={logoutdialog}
                onClose={() => setlogoutdialog(false)}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Confirm exit!
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to logout from this platform?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => setlogoutdialog(false)}>
                        Cancel
                    </Button>
                    <Button onClick={onlogout}>Logout</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showcloseaccount}
                onClose={() => setshowcloseaccount(false)}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Confirm account closure!
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to close your account?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => setshowcloseaccount(false)}>
                        Cancel
                    </Button>
                    <Button onClick={onlogout}>Close account</Button>
                </DialogActions>
            </Dialog>
            <CssBaseline />
            {loading && <Loadingspinner />}
            <Box component="main" sx={{ flexGrow: 1, pb: 20 }} maxWidth="sm">
                <Routes >
                    <Route path="/" exact element={<Navigate replace to="/home" />} />
                    <Route path="/home" exact element={<Home onrefresh={onrefresh} />} />
                    <Route path="/itemsearch" exact element={<Searchitempage onrefresh={onrefresh} />} />
                    <Route path="/todays-deals" exact element={<Flashsales onrefresh={onrefresh} />} />

                    {/* product */}
                    <Route path="/product/:code" element={<ProductPage />} />

                    {/* categories */}
                    <Route path="/categories" element={<Allcategories />} />
                    <Route path="/categoryitems" element={<Categoryitems />} />

                    {/**Account */}
                    <Route path="/account" element={<Account onrefresh={onrefresh} oncloseaccount={() => setshowcloseaccount(true)} onlogout={() => setlogoutdialog(true)} />} exact />
                    <Route path="/useraccount" element={<Useraccount onrefresh={onrefresh} />} exact />
                    <Route path="/security" element={<Security onrefresh={onrefresh} />} exact />
                    <Route path="/saveditems" element={<Saveditems onrefresh={onrefresh} />} exact />
                    <Route path="/recents" element={<Recentlyviewedpage onrefresh={onrefresh} />} exact />
                    <Route path="/lastsearched" element={<Recentlysearchedpage onrefresh={onrefresh} />} exact />
                    <Route path="/cart" element={<Cart onrefresh={onrefresh} />} exact />
                    <Route path="/checkout" element={<Checkoutpage onrefresh={onrefresh} />} exact />
                    <Route path="/orders" element={<Orderspage onrefresh={onrefresh} />} exact />
                    <Route path="/profilesettings" element={<Profilesettings onrefresh={onrefresh} />} exact />


                    {/**Help */}
                    <Route path="/help" element={<Help onrefresh={onrefresh} />} exact />
                    <Route path="/faqs" element={<Faqs onrefresh={onrefresh} />} exact />

                </Routes>
            </Box>
            <Tabs value={value} onChange={handleChange} sx={bottomtabstyle} aria-label="icon label tabs example" variant='fullWidth'>
                <Tab sx={tabtextstyle} onClick={() => navigate("home")} icon={<HomeOutlined size={17} />} label="Home" />
                <Tab sx={tabtextstyle} onClick={() => navigate("categories")} icon={<ListAlt size={17} />} label="Categories" />
                <Tab sx={tabtextstyle} onClick={() => navigate("account")} icon={
                    <Badge badgeContent={cart} color="success" >
                        <PersonOutline />
                    </Badge>} label="Account" />
                <Tab sx={tabtextstyle} onClick={() => navigate("help")} icon={<HelpOutline size={17} />} label="Help" />
            </Tabs>
            <Fab
                color="secondary"
                aria-label="location"
                sx={{
                    position: 'fixed',
                    bottom: 80,
                    right: 16,
                    zIndex: 1000,
                }}
                onClick={() => setLocationOpen(true)}
            >
                <PlaceOutlined />
            </Fab>
            <LocationModal open={locationOpen} onClose={() => setLocationOpen(false)} />
        </Box>
    );
}